<template>
	<div class="card">
		<div class="card-header">
			<el-space class="w-100 justify-content-between">
				<span class="fs-6">Progres Kelengkapan Data Rinci Siswa</span>
				<el-tooltip content="Persentase Total">
					<transition name="slide-up" mode="out-in">
						<strong class="fs-5" :key="progresData.progres_total" :class="progresData.progres_total_class"> {{ progresData.progres_total }}% </strong>
					</transition>
				</el-tooltip>
			</el-space>
		</div>
		<div class="card-body">
			<div v-loading="loading">
				<div class="fs-5 text-center">{{ progresData.nama || "-" }}</div>
				<el-space class="w-100 justify-content-center" :spacer="spacer" :size="0">
					<span>{{ progresData.nama_rombel || "-" }}</span>
					<span>{{ progresData.nis || "-" }}</span>
					<el-tooltip :content="progresData.kunci_data ? `Akses edit terkunci` : `Akses edit terbuka`">
						<el-icon v-if="progresData.kunci_data" class="text-secondary"><Lock /></el-icon>
						<el-icon v-else class="text-success"><Unlock /></el-icon>
					</el-tooltip>
				</el-space>
			</div>
			<hr />
			<el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabClick" :before-leave="beforeLeaveTab">
				<el-tab-pane label="Detail" name="detail" />
				<el-tab-pane label="Data Ayah" name="data-ayah" />
				<el-tab-pane label="Data Ibu" name="data-ibu" />
				<el-tab-pane label="Data Wali" name="data-wali" />
				<router-view
					:progres-data="progresData"
					:data-rinci-siswa="dataRinciSiswa"
					:loading-data="loadingData"
					:form-options="formOptions"
					:refresh-data-parent="refreshDataParent"
					:refresh-form-option="refreshFormOption"
					:update-editing="updateEditing"
					:fields-status-ortu="fieldsStatusOrtu"
					:siswa-id="siswaId"
					:is-pengelola="isPengelola"
					:is-wali-kelas="isWaliKelas"
					:is-siswa="isSiswa"
					:breakpoint="breakpoint"
					v-slot="{ Component }">
					<transition name="fade" mode="out-in">
						<el-form inline label-suffix=" :" class="text-center" v-if="['home', 'rombel-siswa-progres', 'siswa-progres'].includes($route.name)" v-loading="loading">
							<el-form-item label="Detail Siswa" class="my-0">
								<transition name="slide-up" mode="out-in">
									<el-button link @click="handleTabClick('detail')" :key="progresData.progres_detail_siswa" :class="progresData.progres_detail_siswa_class">
										{{ progresData.progres_detail_siswa }}%
									</el-button>
								</transition>
							</el-form-item>
							<el-form-item label="Data Ayah" class="my-0">
								<transition name="slide-up" mode="out-in">
									<el-button link @click="handleTabClick('data-ayah')" :key="progresData.progres_data_ayah" :class="progresData.progres_data_ayah_class">
										{{ progresData.progres_data_ayah }}%
									</el-button>
								</transition>
							</el-form-item>
							<el-form-item label="Data Ibu" class="my-0">
								<transition name="slide-up" mode="out-in">
									<el-button link @click="handleTabClick('data-ibu')" :key="progresData.progres_data_ibu" :class="progresData.progres_data_ibu_class">
										{{ progresData.progres_data_ibu }}%
									</el-button>
								</transition>
							</el-form-item>
							<el-form-item label="Data Wali" class="my-0">
								<transition name="slide-up" mode="out-in">
									<el-button link @click="handleTabClick('data-wali')" :key="progresData.progres_data_wali" :class="progresData.progres_data_wali_class">
										{{ progresData.progres_data_wali }}%
									</el-button>
								</transition>
							</el-form-item>
						</el-form>
						<component :is="Component" v-else />
					</transition>
				</router-view>
			</el-tabs>
		</div>
	</div>
</template>

<script>
import { ElDivider } from "element-plus";
import { h } from "vue";
export default {
	name: "ProgresSiswaView",
	data() {
		return {
			spacer: h(ElDivider, { direction: "vertical" }),
			progresData: {},
			dataRinciSiswa: {
				detailSiswa: null,
				dataAyah: null,
				dataIbu: null,
				dataWali: null,
			},
			loadingData: {
				detailSiswa: true,
				dataAyah: true,
				dataIbu: true,
				dataWali: true,
			},
			tabKeyMap: {
				detail: "detailSiswa",
				"data-ayah": "dataAyah",
				"data-ibu": "dataIbu",
				"data-wali": "dataWali",
			},
			fetchDataMap: {
				detailSiswa: async () => await this.getDetailSiswa(),
				dataAyah: async () => await this.getDataAyah(),
				dataIbu: async () => await this.getDataIbu(),
				dataWali: async () => await this.getDataWali(),
			},
			formOptions: {
				listKebutuhanKhusus: [],
				listProvinsi: [],
				listTempatTinggal: [],
				listModaTransportasi: [],
				listPendidikanDasar: [],
				listHobi: [],
				listCitaCita: [],
				listPekerjaan: [],
				listPendidikan: [],
				listPenghasilan: [],
				listStatusOrtu: [],
			},
			fetchOptionStatus: {
				listKebutuhanKhusus: false,
				listProvinsi: false,
				listTempatTinggal: false,
				listModaTransportasi: false,
				listPendidikanDasar: false,
				listHobi: false,
				listCitaCita: false,
				listPekerjaan: false,
				listPendidikan: false,
				listPenghasilan: false,
				listStatusOrtu: false,
			},
			fetchOptionMap: {
				listKebutuhanKhusus: async () => await this.getListKebutuhanKhusus(),
				listProvinsi: async () => await this.getListProvinsi(),
				listTempatTinggal: async () => await this.getListTempatTinggal(),
				listModaTransportasi: async () => await this.getListModaTransportasi(),
				listPendidikanDasar: async () => await this.getListPendidikanDasar(),
				listHobi: async () => await this.getListHobi(),
				listCitaCita: async () => await this.getListCitaCita(),
				listPekerjaan: async () => await this.getListPekerjaan(),
				listPendidikan: async () => await this.getListPendidikan(),
				listPenghasilan: async () => await this.getListPenghasilan(),
				listStatusOrtu: async () => await this.getListStatusOrtu(),
			},
			fieldsStatusOrtu: null,
			loading: true,
			activeTab: "",
			isEditing: false,
			breakpoint: "md",
			updatedDetailSiswa: (data) => {
				const d = JSON.parse(data);
				if (this.siswaId === d.siswa_id) {
					if (this.dataRinciSiswa["detailSiswa"]) this.getDetailSiswa();
					this.getProgresDataSiswa();
				}
			},
			updatedDataAyah: (data) => {
				const d = JSON.parse(data);
				if (this.siswaId === d.siswa_id) {
					if (this.dataRinciSiswa["dataAyah"]) this.getDataAyah();
					this.getProgresDataSiswa();
				}
			},
			updatedDataIbu: (data) => {
				const d = JSON.parse(data);
				if (this.siswaId === d.siswa_id) {
					if (this.dataRinciSiswa["dataIbu"]) this.getDataIbu();
					this.getProgresDataSiswa();
				}
			},
			updatedDataWali: (data) => {
				const d = JSON.parse(data);
				if (this.siswaId === d.siswa_id) {
					if (this.dataRinciSiswa["dataWali"]) this.getDataWali();
					this.getProgresDataSiswa();
				}
			},
			changedKunciDataSiswa: (data) => {
				const d = JSON.parse(data);
				const siswaIds = d.siswa_ids || [];

				if (siswaIds.includes(this.siswaId)) {
					this.progresData.kunci_data = d.kunci_data;
				}
			},
			insertedBerkebutuhanKhusus: () => {
				if (this.fetchOptionStatus["listKebutuhanKhusus"]) this.getListKebutuhanKhusus();
			},
			updatedBerkebutuhanKhusus: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listKebutuhanKhusus"]) {
					const oldData = this.formOptions["listKebutuhanKhusus"].find((l) => l.berkebutuhan_khusus_id === d.berkebutuhan_khusus_id);
					if (oldData) oldData.jenis = d.jenis;
				}
				if (this.dataRinciSiswa["detailSiswa"] && this.dataRinciSiswa["detailSiswa"].berkebutuhan_khusus_id === d.berkebutuhan_khusus_id) {
					this.dataRinciSiswa["detailSiswa"].jenis_kebutuhan_khusus = d.jenis;
				}
				if (this.dataRinciSiswa["dataAyah"] && this.dataRinciSiswa["dataAyah"].berkebutuhan_khusus_id === d.berkebutuhan_khusus_id) {
					this.dataRinciSiswa["dataAyah"].jenis_kebutuhan_khusus = d.jenis;
				}
				if (this.dataRinciSiswa["dataIbu"] && this.dataRinciSiswa["dataIbu"].berkebutuhan_khusus_id === d.berkebutuhan_khusus_id) {
					this.dataRinciSiswa["dataIbu"].jenis_kebutuhan_khusus = d.jenis;
				}
				if (this.dataRinciSiswa["dataWali"] && this.dataRinciSiswa["dataWali"].berkebutuhan_khusus_id === d.berkebutuhan_khusus_id) {
					this.dataRinciSiswa["dataWali"].jenis_kebutuhan_khusus = d.jenis;
				}
			},
			deletedBerkebutuhanKhusus: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listKebutuhanKhusus"]) {
					const oldIndex = this.formOptions["listKebutuhanKhusus"].findIndex((l) => l.berkebutuhan_khusus_id === d.berkebutuhan_khusus_id);
					if (oldIndex >= 0) this.formOptions["listKebutuhanKhusus"].splice(oldIndex, 1);
				}
				if (this.dataRinciSiswa["detailSiswa"] && this.dataRinciSiswa["detailSiswa"].berkebutuhan_khusus_id === d.berkebutuhan_khusus_id) {
					this.dataRinciSiswa["detailSiswa"].berkebutuhan_khusus_id = null;
					this.dataRinciSiswa["detailSiswa"].jenis_kebutuhan_khusus = null;
				}
				if (this.dataRinciSiswa["dataAyah"] && this.dataRinciSiswa["dataAyah"].berkebutuhan_khusus_id === d.berkebutuhan_khusus_id) {
					this.dataRinciSiswa["dataAyah"].berkebutuhan_khusus_id = null;
					this.dataRinciSiswa["dataAyah"].jenis_kebutuhan_khusus = null;
				}
				if (this.dataRinciSiswa["dataIbu"] && this.dataRinciSiswa["dataIbu"].berkebutuhan_khusus_id === d.berkebutuhan_khusus_id) {
					this.dataRinciSiswa["dataIbu"].berkebutuhan_khusus_id = null;
					this.dataRinciSiswa["dataIbu"].jenis_kebutuhan_khusus = null;
				}
				if (this.dataRinciSiswa["dataWali"] && this.dataRinciSiswa["dataWali"].berkebutuhan_khusus_id === d.berkebutuhan_khusus_id) {
					this.dataRinciSiswa["dataWali"].berkebutuhan_khusus_id = null;
					this.dataRinciSiswa["dataWali"].jenis_kebutuhan_khusus = null;
				}
			},
			insertedTempatTinggal: () => {
				if (this.fetchOptionStatus["listTempatTinggal"]) this.getListTempatTinggal();
			},
			updatedTempatTinggal: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listTempatTinggal"]) {
					const oldData = this.formOptions["listTempatTinggal"].find((l) => l.tempat_tinggal_id === d.tempat_tinggal_id);
					if (oldData) oldData.jenis = d.jenis;
				}
				if (this.dataRinciSiswa["detailSiswa"] && this.dataRinciSiswa["detailSiswa"].tempat_tinggal_id === d.tempat_tinggal_id) {
					this.dataRinciSiswa["detailSiswa"].jenis_tempat_tinggal = d.jenis;
				}
			},
			deletedTempatTinggal: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listTempatTinggal"]) {
					const oldIndex = this.formOptions["listTempatTinggal"].findIndex((l) => l.tempat_tinggal_id === d.tempat_tinggal_id);
					if (oldIndex >= 0) this.formOptions["listTempatTinggal"].splice(oldIndex, 1);
				}
				if (this.dataRinciSiswa["detailSiswa"] && this.dataRinciSiswa["detailSiswa"].tempat_tinggal_id === d.tempat_tinggal_id) {
					this.dataRinciSiswa["detailSiswa"].tempat_tinggal_id = null;
					this.dataRinciSiswa["detailSiswa"].jenis_tempat_tinggal = null;
				}
			},
			insertedModaTransportasi: () => {
				if (this.fetchOptionStatus["listModaTransportasi"]) this.getListModaTransportasi();
			},
			updatedModaTransportasi: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listModaTransportasi"]) {
					const oldData = this.formOptions["listModaTransportasi"].find((l) => l.moda_transportasi_id === d.moda_transportasi_id);
					if (oldData) oldData.jenis = d.jenis;
				}
				if (this.dataRinciSiswa["detailSiswa"] && this.dataRinciSiswa["detailSiswa"].moda_transportasi_id === d.moda_transportasi_id) {
					this.dataRinciSiswa["detailSiswa"].jenis_transportasi = d.jenis;
				}
			},
			deletedModaTransportasi: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listModaTransportasi"]) {
					const oldIndex = this.formOptions["listModaTransportasi"].findIndex((l) => l.moda_transportasi_id === d.moda_transportasi_id);
					if (oldIndex >= 0) this.formOptions["listModaTransportasi"].splice(oldIndex, 1);
				}
				if (this.dataRinciSiswa["detailSiswa"] && this.dataRinciSiswa["detailSiswa"].moda_transportasi_id === d.moda_transportasi_id) {
					this.dataRinciSiswa["detailSiswa"].moda_transportasi_id = null;
					this.dataRinciSiswa["detailSiswa"].jenis_transportasi = null;
				}
			},
			insertedPendidikanDasar: () => {
				if (this.fetchOptionStatus["listPendidikanDasar"]) this.getListPendidikanDasar();
			},
			updatedPendidikanDasar: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listPendidikanDasar"]) {
					const oldData = this.formOptions["listPendidikanDasar"].find((l) => l.pendidikan_dasar_id === d.pendidikan_dasar_id);
					if (oldData) oldData.jenis = d.jenis;
				}
				if (this.dataRinciSiswa["detailSiswa"] && this.dataRinciSiswa["detailSiswa"].pendidikan_dasar_id === d.pendidikan_dasar_id) {
					this.dataRinciSiswa["detailSiswa"].singkatan_pd = d.singkatan;
					this.dataRinciSiswa["detailSiswa"].deskripsi_pd = d.deskripsi;
				}
			},
			deletedPendidikanDasar: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listPendidikanDasar"]) {
					const oldIndex = this.formOptions["listPendidikanDasar"].findIndex((l) => l.pendidikan_dasar_id === d.pendidikan_dasar_id);
					if (oldIndex >= 0) this.formOptions["listPendidikanDasar"].splice(oldIndex, 1);
				}
				if (this.dataRinciSiswa["detailSiswa"] && this.dataRinciSiswa["detailSiswa"].pendidikan_dasar_id === d.pendidikan_dasar_id) {
					this.dataRinciSiswa["detailSiswa"].pendidikan_dasar_id = null;
					this.dataRinciSiswa["detailSiswa"].singkatan_pd = null;
					this.dataRinciSiswa["detailSiswa"].deskripsi_pd = null;
				}
			},
			insertedHobi: () => {
				if (this.fetchOptionStatus["listHobi"]) this.getListHobi();
			},
			updatedHobi: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listHobi"]) {
					const oldData = this.formOptions["listHobi"].find((l) => l.hobi_id === d.hobi_id);
					if (oldData) oldData.nama = d.nama;
				}
				if (this.dataRinciSiswa["detailSiswa"] && this.dataRinciSiswa["detailSiswa"].hobi_id === d.hobi_id) {
					this.dataRinciSiswa["detailSiswa"].nama_hobi = d.nama;
				}
			},
			deletedHobi: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listHobi"]) {
					const oldIndex = this.formOptions["listHobi"].findIndex((l) => l.hobi_id === d.hobi_id);
					if (oldIndex >= 0) this.formOptions["listHobi"].splice(oldIndex, 1);
				}
				if (this.dataRinciSiswa["detailSiswa"] && this.dataRinciSiswa["detailSiswa"].hobi_id === d.hobi_id) {
					this.dataRinciSiswa["detailSiswa"].hobi_id = null;
					this.dataRinciSiswa["detailSiswa"].nama_hobi = null;
				}
			},
			insertedCitaCita: () => {
				if (this.fetchOptionStatus["listCitaCita"]) this.getListCitaCita();
			},
			updatedCitaCita: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listCitaCita"]) {
					const oldData = this.formOptions["listCitaCita"].find((l) => l.cita_cita_id === d.cita_cita_id);
					if (oldData) oldData.nama = d.nama;
				}
				if (this.dataRinciSiswa["detailSiswa"] && this.dataRinciSiswa["detailSiswa"].cita_cita_id === d.cita_cita_id) {
					this.dataRinciSiswa["detailSiswa"].nama_cita_cita = d.nama;
				}
			},
			deletedCitaCita: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listCitaCita"]) {
					const oldIndex = this.formOptions["listCitaCita"].findIndex((l) => l.cita_cita_id === d.cita_cita_id);
					if (oldIndex >= 0) this.formOptions["listCitaCita"].splice(oldIndex, 1);
				}
				if (this.dataRinciSiswa["detailSiswa"] && this.dataRinciSiswa["detailSiswa"].cita_cita_id === d.cita_cita_id) {
					this.dataRinciSiswa["detailSiswa"].cita_cita_id = null;
					this.dataRinciSiswa["detailSiswa"].nama_cita_cita = null;
				}
			},
			insertedPekerjaan: () => {
				if (this.fetchOptionStatus["listPekerjaan"]) this.getListPekerjaan();
			},
			updatedPekerjaan: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listPekerjaan"]) {
					const oldData = this.formOptions["listPekerjaan"].find((l) => l.pekerjaan_id === d.pekerjaan_id);
					if (oldData) oldData.nama = d.nama;
				}
				if (this.dataRinciSiswa["dataAyah"] && this.dataRinciSiswa["dataAyah"].pekerjaan_id === d.pekerjaan_id) {
					this.dataRinciSiswa["dataAyah"].nama_pekerjaan = d.nama;
				}
				if (this.dataRinciSiswa["dataIbu"] && this.dataRinciSiswa["dataIbu"].pekerjaan_id === d.pekerjaan_id) {
					this.dataRinciSiswa["dataIbu"].nama_pekerjaan = d.nama;
				}
				if (this.dataRinciSiswa["dataWali"] && this.dataRinciSiswa["dataWali"].pekerjaan_id === d.pekerjaan_id) {
					this.dataRinciSiswa["dataWali"].nama_pekerjaan = d.nama;
				}
			},
			deletedPekerjaan: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listPekerjaan"]) {
					const oldIndex = this.formOptions["listPekerjaan"].findIndex((l) => l.pekerjaan_id === d.pekerjaan_id);
					if (oldIndex >= 0) this.formOptions["listPekerjaan"].splice(oldIndex, 1);
				}
				if (this.dataRinciSiswa["dataAyah"] && this.dataRinciSiswa["dataAyah"].pekerjaan_id === d.pekerjaan_id) {
					this.dataRinciSiswa["dataAyah"].pekerjaan_id = null;
					this.dataRinciSiswa["dataAyah"].nama_pekerjaan = null;
				}
				if (this.dataRinciSiswa["dataIbu"] && this.dataRinciSiswa["dataIbu"].pekerjaan_id === d.pekerjaan_id) {
					this.dataRinciSiswa["dataIbu"].pekerjaan_id = null;
					this.dataRinciSiswa["dataIbu"].nama_pekerjaan = null;
				}
				if (this.dataRinciSiswa["dataWali"] && this.dataRinciSiswa["dataWali"].pekerjaan_id === d.pekerjaan_id) {
					this.dataRinciSiswa["dataWali"].pekerjaan_id = null;
					this.dataRinciSiswa["dataWali"].nama_pekerjaan = null;
				}
			},
			insertedPendidikan: () => {
				if (this.fetchOptionStatus["listPendidikan"]) this.getListPendidikan();
			},
			updatedPendidikan: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listPendidikan"]) {
					const oldData = this.formOptions["listPendidikan"].find((l) => l.pendidikan_id === d.pendidikan_id);
					if (oldData) oldData.jenjang = d.jenjang;
				}
				if (this.dataRinciSiswa["dataAyah"] && this.dataRinciSiswa["dataAyah"].pendidikan_id === d.pendidikan_id) {
					this.dataRinciSiswa["dataAyah"].jenjang_pendidikan = d.jenjang;
				}
				if (this.dataRinciSiswa["dataIbu"] && this.dataRinciSiswa["dataIbu"].pendidikan_id === d.pendidikan_id) {
					this.dataRinciSiswa["dataIbu"].jenjang_pendidikan = d.jenjang;
				}
				if (this.dataRinciSiswa["dataWali"] && this.dataRinciSiswa["dataWali"].pendidikan_id === d.pendidikan_id) {
					this.dataRinciSiswa["dataWali"].jenjang_pendidikan = d.jenjang;
				}
			},
			deletedPendidikan: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listPendidikan"]) {
					const oldIndex = this.formOptions["listPendidikan"].findIndex((l) => l.pendidikan_id === d.pendidikan_id);
					if (oldIndex >= 0) this.formOptions["listPendidikan"].splice(oldIndex, 1);
				}
				if (this.dataRinciSiswa["dataAyah"] && this.dataRinciSiswa["dataAyah"].pendidikan_id === d.pendidikan_id) {
					this.dataRinciSiswa["dataAyah"].pendidikan_id = null;
					this.dataRinciSiswa["dataAyah"].jenjang_pendidikan = null;
				}
				if (this.dataRinciSiswa["dataIbu"] && this.dataRinciSiswa["dataIbu"].pendidikan_id === d.pendidikan_id) {
					this.dataRinciSiswa["dataIbu"].pendidikan_id = null;
					this.dataRinciSiswa["dataIbu"].jenjang_pendidikan = null;
				}
				if (this.dataRinciSiswa["dataWali"] && this.dataRinciSiswa["dataWali"].pekerjaan_id === d.pendidikan_id) {
					this.dataRinciSiswa["dataWali"].pendidikan_id = null;
					this.dataRinciSiswa["dataWali"].jenjang_pendidikan = null;
				}
			},
			insertedPenghasilan: () => {
				if (this.fetchOptionStatus["listPenghasilan"]) this.getListPenghasilan();
			},
			updatedPenghasilan: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listPenghasilan"]) {
					const oldData = this.formOptions["listPenghasilan"].find((l) => l.penghasilan_id === d.penghasilan_id);
					if (oldData) oldData.rentang = d.rentang;
				}
				if (this.dataRinciSiswa["dataAyah"] && this.dataRinciSiswa["dataAyah"].penghasilan_id === d.penghasilan_id) {
					this.dataRinciSiswa["dataAyah"].rentang_penghasilan = d.rentang;
				}
				if (this.dataRinciSiswa["dataIbu"] && this.dataRinciSiswa["dataIbu"].penghasilan_id === d.penghasilan_id) {
					this.dataRinciSiswa["dataIbu"].rentang_penghasilan = d.rentang;
				}
				if (this.dataRinciSiswa["dataWali"] && this.dataRinciSiswa["dataWali"].penghasilan_id === d.penghasilan_id) {
					this.dataRinciSiswa["dataWali"].rentang_penghasilan = d.rentang;
				}
			},
			deletedPenghasilan: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listPenghasilan"]) {
					const oldIndex = this.formOptions["listPenghasilan"].findIndex((l) => l.penghasilan_id === d.penghasilan_id);
					if (oldIndex >= 0) this.formOptions["listPenghasilan"].splice(oldIndex, 1);
				}
				if (this.dataRinciSiswa["dataAyah"] && this.dataRinciSiswa["dataAyah"].penghasilan_id === d.penghasilan_id) {
					this.dataRinciSiswa["dataAyah"].penghasilan_id = null;
					this.dataRinciSiswa["dataAyah"].rentang_penghasilan = null;
				}
				if (this.dataRinciSiswa["dataIbu"] && this.dataRinciSiswa["dataIbu"].penghasilan_id === d.penghasilan_id) {
					this.dataRinciSiswa["dataIbu"].penghasilan_id = null;
					this.dataRinciSiswa["dataIbu"].rentang_penghasilan = null;
				}
				if (this.dataRinciSiswa["dataWali"] && this.dataRinciSiswa["dataWali"].penghasilan_id === d.penghasilan_id) {
					this.dataRinciSiswa["dataWali"].penghasilan_id = null;
					this.dataRinciSiswa["dataWali"].rentang_penghasilan = null;
				}
			},
			insertedStatusOrtu: () => {
				if (this.fetchOptionStatus["listStatusOrtu"]) this.getListStatusOrtu();
			},
			updatedStatusOrtu: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listStatusOrtu"]) {
					const oldData = this.formOptions["listStatusOrtu"].find((l) => l.status_ortu_id === d.status_ortu_id);
					if (oldData) oldData.deskripsi = d.deskripsi;
				}
				if (this.dataRinciSiswa["dataAyah"] && this.dataRinciSiswa["dataAyah"].status_ortu_id === d.status_ortu_id) {
					this.dataRinciSiswa["dataAyah"].deskripsi_status = d.deskripsi;
				}
				if (this.dataRinciSiswa["dataIbu"] && this.dataRinciSiswa["dataIbu"].status_ortu_id === d.status_ortu_id) {
					this.dataRinciSiswa["dataIbu"].deskripsi_status = d.deskripsi;
				}
			},
			deletedStatusOrtu: (data) => {
				const d = JSON.parse(data);
				if (this.fetchOptionStatus["listStatusOrtu"]) {
					const oldIndex = this.formOptions["listStatusOrtu"].findIndex((l) => l.status_ortu_id === d.status_ortu_id);
					if (oldIndex >= 0) this.formOptions["listStatusOrtu"].splice(oldIndex, 1);
				}
				if (this.dataRinciSiswa["dataAyah"] && this.dataRinciSiswa["dataAyah"].status_ortu_id === d.status_ortu_id) {
					this.dataRinciSiswa["dataAyah"].status_ortu_id = null;
					this.dataRinciSiswa["dataAyah"].deskripsi_status = null;
				}
				if (this.dataRinciSiswa["dataIbu"] && this.dataRinciSiswa["dataIbu"].status_ortu_id === d.status_ortu_id) {
					this.dataRinciSiswa["dataIbu"].status_ortu_id = null;
					this.dataRinciSiswa["dataIbu"].deskripsi_status = null;
				}
			},
		};
	},
	computed: {
		routeParent() {
			const matched = this.$route.matched;
			const name = matched[0]?.name;
			return name;
		},
		isPengelola() {
			const roles = this.$store.getters.getRoles;
			return roles?.some((r) => ["dev", "superadmin", "admin-kesiswaan", "admin-buku-induk", "pengelola"].includes(r.role));
		},
		isWaliKelas() {
			const user = this.$store.getters.getUser;
			const roles = this.$store.getters.getRoles;
			return roles?.some((r) => r.role === "wali-kelas") && user?.type === "guru" && user?.guru_id === this.progresData.wali_kelas;
		},
		isSiswa() {
			const user = this.$store.getters.getUser;
			return user?.type === "siswa" && user?.siswa_id === this.siswaId;
		},
		siswaId() {
			const user = this.$store.getters.getUser;
			if (user.type === "siswa") return user.siswa_id;
			return Number(this.$route.params.siswaId);
		},
		lastPath() {
			const paths = this.$route.path.split("/");
			return paths[paths.length - 1];
		},
	},
	watch: {
		siswaId: {
			immediate: true,
			async handler(id) {
				if (!id) return;
				this.$store.dispatch("siswa/fetchData", id);
				this.resetData();
				await this.getProgresDataSiswa();
			},
		},
		lastPath: {
			immediate: true,
			async handler(val) {
				this.activeTab = val;

				if (!val) return;
				if (val === "data-ayah" || val === "data-ibu") {
					if (!this.fieldsStatusOrtu) await this.getDataStatusOrtu();
				}

				const tabKey = this.tabKeyMap[val];
				if (!tabKey) return;

				if (this.dataRinciSiswa[tabKey]) return;

				if (!this.fetchDataMap[tabKey]) return;

				this.loadingData[tabKey] = true;
				await this.fetchDataMap[tabKey]();
				setTimeout(() => {
					this.loadingData[tabKey] = false;
				}, 500);
			},
		},
	},
	mounted() {
		this.handleResize();
		window.addEventListener("resize", this.handleResize);
		window.addEventListener("beforeunload", this.handleBeforeUnload);
		this.$ws.main.on("detail-siswa:updated", this.updatedDetailSiswa);
		this.$ws.main.on("data-ayah:updated", this.updatedDataAyah);
		this.$ws.main.on("data-ibu:updated", this.updatedDataIbu);
		this.$ws.main.on("data-wali:updated", this.updatedDataWali);
		this.$ws.main.on("kunci-data:changed", this.changedKunciDataSiswa);
		this.$ws.main.on("berkebutuhan-khusus:inserted", this.insertedBerkebutuhanKhusus);
		this.$ws.main.on("berkebutuhan-khusus:updated", this.updatedBerkebutuhanKhusus);
		this.$ws.main.on("berkebutuhan-khusus:deleted", this.deletedBerkebutuhanKhusus);
		this.$ws.main.on("cita-cita:inserted", this.insertedCitaCita);
		this.$ws.main.on("cita-cita:updated", this.updatedCitaCita);
		this.$ws.main.on("cita-cita:deleted", this.deletedCitaCita);
		this.$ws.main.on("hobi:inserted", this.insertedHobi);
		this.$ws.main.on("hobi:updated", this.updatedHobi);
		this.$ws.main.on("hobi:deleted", this.deletedHobi);
		this.$ws.main.on("moda-transportasi:inserted", this.insertedModaTransportasi);
		this.$ws.main.on("moda-transportasi:updated", this.updatedModaTransportasi);
		this.$ws.main.on("moda-transportasi:deleted", this.deletedModaTransportasi);
		this.$ws.main.on("pekerjaan:inserted", this.insertedPekerjaan);
		this.$ws.main.on("pekerjaan:updated", this.updatedPekerjaan);
		this.$ws.main.on("pekerjaan:deleted", this.deletedPekerjaan);
		this.$ws.main.on("pendidikan:inserted", this.insertedPendidikan);
		this.$ws.main.on("pendidikan:updated", this.updatedPendidikan);
		this.$ws.main.on("pendidikan:deleted", this.deletedPendidikan);
		this.$ws.main.on("pendidikan-dasar:inserted", this.insertedPendidikanDasar);
		this.$ws.main.on("pendidikan-dasar:updated", this.updatedPendidikanDasar);
		this.$ws.main.on("pendidikan-dasar:deleted", this.deletedPendidikanDasar);
		this.$ws.main.on("penghasilan:inserted", this.insertedPenghasilan);
		this.$ws.main.on("penghasilan:updated", this.updatedPenghasilan);
		this.$ws.main.on("penghasilan:deleted", this.deletedPenghasilan);
		this.$ws.main.on("status-ortu:inserted", this.insertedStatusOrtu);
		this.$ws.main.on("status-ortu:updated", this.updatedStatusOrtu);
		this.$ws.main.on("status-ortu:deleted", this.deletedStatusOrtu);
		this.$ws.main.on("tempat-tinggal:inserted", this.insertedTempatTinggal);
		this.$ws.main.on("tempat-tinggal:updated", this.updatedTempatTinggal);
		this.$ws.main.on("tempat-tinggal:deleted", this.deletedTempatTinggal);
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.handleResize);
		window.removeEventListener("beforeunload", this.handleBeforeUnload);
		this.$ws.main.off("detail-siswa:updated");
		this.$ws.main.off("data-ayah:updated");
		this.$ws.main.off("data-ibu:updated");
		this.$ws.main.off("data-wali:updated");
		this.$ws.main.off("kunci-data:changed");
		this.$ws.main.off("berkebutuhan-khusus:inserted");
		this.$ws.main.off("berkebutuhan-khusus:updated");
		this.$ws.main.off("berkebutuhan-khusus:deleted");
		this.$ws.main.off("cita-cita:inserted");
		this.$ws.main.off("cita-cita:updated");
		this.$ws.main.off("cita-cita:deleted");
		this.$ws.main.off("hobi:inserted");
		this.$ws.main.off("hobi:updated");
		this.$ws.main.off("hobi:deleted");
		this.$ws.main.off("moda-transportasi:inserted");
		this.$ws.main.off("moda-transportasi:updated");
		this.$ws.main.off("moda-transportasi:deleted");
		this.$ws.main.off("pekerjaan:inserted");
		this.$ws.main.off("pekerjaan:updated");
		this.$ws.main.off("pekerjaan:deleted");
		this.$ws.main.off("pendidikan:inserted");
		this.$ws.main.off("pendidikan:updated");
		this.$ws.main.off("pendidikan:deleted");
		this.$ws.main.off("pendidikan-dasar:inserted");
		this.$ws.main.off("pendidikan-dasar:updated");
		this.$ws.main.off("pendidikan-dasar:deleted");
		this.$ws.main.off("penghasilan:inserted");
		this.$ws.main.off("penghasilan:updated");
		this.$ws.main.off("penghasilan:deleted");
		this.$ws.main.off("status-ortu:inserted");
		this.$ws.main.off("status-ortu:updated");
		this.$ws.main.off("status-ortu:deleted");
		this.$ws.main.off("tempat-tinggal:inserted");
		this.$ws.main.off("tempat-tinggal:updated");
		this.$ws.main.off("tempat-tinggal:deleted");
	},
	methods: {
		resetData() {
			Object.keys(this.dataRinciSiswa).forEach((k) => {
				this.dataRinciSiswa[k] = null;
				this.loadingData[k] = true;
			});
			this.progresData = {};
		},
		async refreshDataParent(key) {
			if (this.dataRinciSiswa[key] || !this.fetchDataMap[key]) return;

			await this.fetchDataMap[key]();
		},
		async refreshFormOption(key) {
			if (!this.formOptions[key] || this.fetchOptionStatus[key] || !this.fetchOptionMap[key]) return;

			await this.fetchOptionMap[key]();
			this.fetchOptionStatus[key] = true;
		},
		updateEditing(val) {
			this.isEditing = val;
		},
		beforeLeaveTab() {
			return new Promise((resolve, reject) => {
				if (this.isEditing) {
					reject();
				}
				resolve();
			});
		},

		async getListKebutuhanKhusus() {
			try {
				const { data } = await this.$defaultApi.post("/list/berkebutuhan-khusus", {});

				this.formOptions.listKebutuhanKhusus = data.berkebutuhan_khusus;
				this.formOptions.listKebutuhanKhusus.unshift({
					berkebutuhan_khusus_id: 0,
					jenis: "Tidak ada",
				});
			} catch (error) {
				console.error(error);
			}
		},
		async getListProvinsi() {
			try {
				const { data } = await this.$defaultApi.post("/list/provinsi", {});

				this.formOptions.listProvinsi = data.provinsi;
			} catch (error) {
				console.error(error);
			}
		},
		async getListTempatTinggal() {
			try {
				const { data } = await this.$defaultApi.post("/list/tempat-tinggal", {});

				this.formOptions.listTempatTinggal = data.tempat_tinggal;
			} catch (error) {
				console.error(error);
			}
		},
		async getListModaTransportasi() {
			try {
				const { data } = await this.$defaultApi.post("/list/moda-transportasi", {});

				this.formOptions.listModaTransportasi = data.moda_transportasi;
			} catch (error) {
				console.error(error);
			}
		},
		async getListPendidikanDasar() {
			try {
				const { data } = await this.$defaultApi.post("/list/pendidikan-dasar", {});

				this.formOptions.listPendidikanDasar = data.pendidikan_dasar;
			} catch (error) {
				console.error(error);
			}
		},
		async getListHobi() {
			try {
				const { data } = await this.$defaultApi.post("/list/hobi", {});

				this.formOptions.listHobi = data.hobi;
			} catch (error) {
				console.error(error);
			}
		},
		async getListCitaCita() {
			try {
				const { data } = await this.$defaultApi.post("/list/cita-cita", {});

				this.formOptions.listCitaCita = data.cita_cita;
			} catch (error) {
				console.error(error);
			}
		},
		async getListPekerjaan() {
			try {
				const { data } = await this.$defaultApi.post("/list/pekerjaan", {});

				this.formOptions.listPekerjaan = data.pekerjaan;
				this.formOptions.listKebutuhanKhusus.unshift({
					berkebutuhan_khusus_id: 0,
					jenis: "Tidak ada",
				});
			} catch (error) {
				console.error(error);
			}
		},
		async getListPendidikan() {
			try {
				const { data } = await this.$defaultApi.post("/list/pendidikan", {});

				this.formOptions.listPendidikan = data.pendidikan;
			} catch (error) {
				console.error(error);
			}
		},
		async getListPenghasilan() {
			try {
				const { data } = await this.$defaultApi.post("/list/penghasilan", {});

				this.formOptions.listPenghasilan = data.penghasilan;
			} catch (error) {
				console.error(error);
			}
		},
		async getListStatusOrtu() {
			try {
				const { data } = await this.$defaultApi.post("/list/status-ortu", {});

				this.formOptions.listStatusOrtu = data.status_ortu;
			} catch (error) {
				console.error(error);
			}
		},
		async getDataStatusOrtu() {
			try {
				const { data } = await this.$defaultApi.post("/data/status-ortu", {});

				this.fieldsStatusOrtu = data.status_ortu;
			} catch (error) {
				console.error(error);
			}
		},
		async getProgresDataSiswa() {
			try {
				const { data } = await this.$defaultApi.post("/progres/siswa", {
					siswa_id: this.siswaId,
				});

				const result = data.progres_siswa || {};

				result.progres_detail_siswa_class = this.getTextStyle(result.progres_detail_siswa);
				result.progres_data_ayah_class = this.getTextStyle(result.progres_data_ayah);
				result.progres_data_ibu_class = this.getTextStyle(result.progres_data_ibu);
				result.progres_data_wali_class = this.getTextStyle(result.progres_data_wali);
				result.progres_total_class = this.getTextStyle(result.progres_total);

				this.progresData = result;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				setTimeout(() => {
					this.loading = false;
				}, 500);
			}
		},
		async getDetailSiswa() {
			try {
				const { data } = await this.$defaultApi.post("/detail/siswa", {
					siswa_id: this.siswaId,
				});

				const result = data.detail_siswa;
				result.rt = result.rt?.toString() || null;
				result.rw = result.rw?.toString() || null;
				result.tanggal_lahir_styled = result.tanggal_lahir ? new Date(result.tanggal_lahir).toLocaleString("id-ID", { dateStyle: "long" }) : null;
				result.pernah_paud_formal_text = result.pernah_paud_formal === 1 ? "Ya" : result.pernah_paud_formal === 0 ? "Tidak" : null;
				result.pernah_paud_nonformal_text = result.pernah_paud_nonformal === 1 ? "Ya" : result.pernah_paud_nonformal === 0 ? "Tidak" : null;
				result.updated_at_styled = result.updated_at ? new Date(result.updated_at).toLocaleString("id-ID", { dateStyle: "full", timeStyle: "long" }) : null;
				result.previewFotoDiri = result.foto_diri ? `${process.env.VUE_APP_API}/file/foto-siswa?siswa_id=${this.siswaId}&ts=${Date.now()}` : null;
				result.previewFotoIjazahSMP = result.foto_ijazah_smp ? `${process.env.VUE_APP_API}/file/ijazah?siswa_id=${this.siswaId}&ts=${Date.now()}` : null;
				result.previewFotoKK = result.foto_kk ? `${process.env.VUE_APP_API}/file/kk?siswa_id=${this.siswaId}&ts=${Date.now()}` : null;
				result.previewFotoAkta = result.foto_akta ? `${process.env.VUE_APP_API}/file/akta?siswa_id=${this.siswaId}&ts=${Date.now()}` : null;

				this.dataRinciSiswa["detailSiswa"] = result;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
		async getDataAyah() {
			try {
				const { data } = await this.$defaultApi.post("/detail/ayah", {
					siswa_id: this.siswaId,
				});

				const result = data.data_ayah;
				result.rt = result.rt?.toString() || null;
				result.rw = result.rw?.toString() || null;
				result.tahun_lahir = result.tahun_lahir?.toString() || null;
				result.tahun_wafat = result.tahun_wafat?.toString() || null;
				result.updated_at_styled = result.updated_at ? new Date(result.updated_at).toLocaleString("id-ID", { dateStyle: "full", timeStyle: "long" }) : null;
				result.previewFotoKTP = result.foto_ktp ? `${process.env.VUE_APP_API}/file/ktp-ayah?siswa_id=${this.siswaId}&ts=${Date.now()}` : null;

				this.dataRinciSiswa["dataAyah"] = result;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
		async getDataIbu() {
			try {
				const { data } = await this.$defaultApi.post("/detail/ibu", {
					siswa_id: this.siswaId,
				});

				const result = data.data_ibu;
				result.rt = result.rt?.toString() || null;
				result.rw = result.rw?.toString() || null;
				result.tahun_lahir = result.tahun_lahir?.toString() || null;
				result.tahun_wafat = result.tahun_wafat?.toString() || null;
				result.updated_at_styled = result.updated_at ? new Date(result.updated_at).toLocaleString("id-ID", { dateStyle: "full", timeStyle: "long" }) : null;
				result.previewFotoKTP = result.foto_ktp ? `${process.env.VUE_APP_API}/file/ktp-ibu?siswa_id=${this.siswaId}&ts=${Date.now()}` : null;

				this.dataRinciSiswa["dataIbu"] = result;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
		async getDataWali() {
			try {
				const { data } = await this.$defaultApi.post("/detail/wali", {
					siswa_id: this.siswaId,
				});

				const result = data.data_wali;
				result.rt = result.rt?.toString() || null;
				result.rw = result.rw?.toString() || null;
				result.tahun_lahir = result.tahun_lahir?.toString() || null;
				result.updated_at_styled = result.updated_at ? new Date(result.updated_at).toLocaleString("id-ID", { dateStyle: "full", timeStyle: "long" }) : null;
				result.previewFotoKTP = result.foto_ktp ? `${process.env.VUE_APP_API}/file/ktp-wali?siswa_id=${this.siswaId}&ts=${Date.now()}` : null;

				this.dataRinciSiswa["dataWali"] = result;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
		getTextStyle(val) {
			if (val > 85) return "text-success";
			if (val > 65) return "text-success-emphasis";
			if (val > 35) return "text-warning";
			return "text-danger";
		},
		handleTabClick(val) {
			switch (this.routeParent) {
				case "rombel":
					this.$router.push({ name: "rombel-siswa-" + (val?.paneName || val) });
					break;
				case "siswa":
					this.$router.push({ name: "siswa-" + (val?.paneName || val) });
					break;
				default:
					this.$router.push({ name: val?.paneName || val });
					break;
			}
		},
		handleResize() {
			const w = window.innerWidth;
			if (w < 768) this.breakpoint = "xs";
			else if (w < 992) this.breakpoint = "sm";
			else if (w < 1200) this.breakpoint = "md";
			else if (w < 1920) this.breakpoint = "lg";
			else this.breakpoint = "xl";
		},
		handleBeforeUnload(e) {
			if (this.isEditing) {
				e.preventDefault();
				e.returnValue = "";
				return "";
			}
		},
	},
};
</script>

<style scoped></style>
